import React, { SFC } from "react";
import { Trans, t } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import { useFormikContext } from "formik";

export interface Props {}

export const ResetFormButton: SFC<Props> = () => {
  const { i18n } = useLingui();
  const { resetForm } = useFormikContext();

  const handleClick = React.useCallback(() => {
    if (window.confirm(i18n._(t`Weet u zeker dat u alles wil wissen?`))) {
      resetForm();
    }
  }, [i18n, resetForm]);
  return (
    <div className="process-step">
      <button type="button" className="btn buttonreset btn-info" onClick={handleClick}>
        <i className="fa fa-trash-o fa-2x" title={i18n._(t`Alles wissen`)}></i>
      </button>
      <p>
        <small>
          <Trans>Alles wissen</Trans>
        </small>
      </p>
    </div>
  );
};

ResetFormButton.displayName = "ResetFormButton";
